import React, {useEffect, useState, useContext, Suspense, lazy} from 'react';
import './App.css';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import ResultsForm from "./components/ResultsForm";
// import PatientForm from "./components/PatientForm";
import AdminPanel from "./components/admin/AdminPanel";
// import Confirmation from "./components/Confirmation";
// import PrivatePod from "./components/PrivatePod";
import Login from "./components/admin/Login"; //FC
// import PatientCheckIn from "./components/PatientCheckIn";
// import {RetrieveConfirmation} from "./components/RetrieveConfirmation";
import {TestManagement} from "./components/admin/TestManagement";
import Alert from "./../src/components/admin/Alert";
// import CheckIn from "./components/admin/CheckIn";
import SamplesReport from "./components/admin/SamplesReport";
import WalkinForm from "./components/admin/WalkinForm";
import {Facility} from "./components/admin/Facility";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import LoggedOut from "./components/admin/LoggedOut";
// import RapidTestManagement from "./components/admin/RapidTestManagement";
// // import PodStats from "./components/admin/PodStats";
// import Schedules from "./components/admin/Schedules";
import {AuditLogs} from "./components/admin/AuditLogs";
import {UserManagement} from "./components/admin/UserManagement";
import {ServicesManagement} from "./components/admin/ServicesManagement";
import {ResultsManagement} from "./components/admin/ResultsManagement";
import {CommunicationTemplates} from "./components/admin/CommunicationTemplates";
import AdminHomePage from "./components/admin/AdminHomePage";
import {CustomFields} from "./components/admin/CustomFields";
import { ReportSettings } from './components/admin/ReportSettings';
import { AuthContext } from './context/AuthContext';
import ForgotPassword from './components/admin/ForgotPassword';
import Home from './components/Home';
import SystemAPI from './network/SystemAPI';
import { PatientManagement } from './components/admin/PatientManagement';
import { PasswordSettings } from './components/admin/PasswordSettings';
import { BannerManagement } from './components/admin/BannerManagement';
// import { FakeSampleGenerator } from './components/admin/FakeSampleGenerator';
import { PricingManagement } from './components/admin/PricingManagement';
import { DiscountManagement } from './components/admin/DiscountManagement';
import { DocumentUpload } from './components/admin/DocumentUpload';
import SkipLink from './components/SkipLink';
import { PatientFields } from './components/admin/PatientFields';
import { Transactions } from './components/admin/Transactions';
import { Dashboards } from './components/admin/Dashboards';
// Dev-only preview harness. The NODE_ENV test wraps the lazy() call itself, not
// just the route: webpack substitutes process.env.NODE_ENV at build time, so in
// production this whole expression is dead code and the import() is never
// emitted — no chunk, no fixtures on the server at all. Guarding only the route
// left main.js clean but still shipped a fetchable orphan chunk.
const LazyDashboardPreview =
    process.env.NODE_ENV === 'development'
        ? lazy(() => import('./dashboards/preview/DashboardPreview'))
        : (null as any);
import { ReportsUploadPage } from './components/admin/ReportsUploadPage';
import { SampleCSVImport } from './components/admin/SampleCSVImport';
import { PatientRecord } from './components/admin/PatientRecord';
import CustomFieldsAPI from './network/CustomFieldsAPI';
import  ProbioticsOrderPage  from './components/admin/ProbioticsOrderPage';
import ProductManagmentPage  from './components/admin/ProductManagmentPage';
import OrderHistory from './components/admin/OrderHistory';
import { KitInventoryManagement } from './components/admin/KitInventoryManagement';
import AtHomeKitOrderPage from './components/admin/AtHomeKitOrderPage';

const swal = withReactContent(Swal);

export const CAPTCHA = "6Lc4JUAcAAAAAGPcDlen-26x_KpyZUjY7acuP4Al";

//setting defaults for sweetalert
export let sweetalert = swal.mixin({
    showCloseButton:false, // hide the 'x' at the top of the modal
    confirmButtonColor: '#21212E',      // dark blue
    cancelButtonText: 'Cancel',
    cancelButtonColor: '#808080',       // grey 
    denyButtonColor: '#dc3741',         // standard red
    allowOutsideClick: true,           // enforce user interact with modal buttons
    allowEscapeKey: false,              // enforce user interact with modal buttons
    reverseButtons: true,   // cancel left, confirm right
    // stopKeydownPropagation:false,
    keydownListenerCapture:false,
    // allowEnterKey:true,      
    showClass: {
        backdrop: 'swal2-noanimation',  // disable backdrop animation
        popup: '',                      // disable popup animation
        icon: '',                       // disable icon animation
    },
    hideClass: {
        popup: '',                     // disable popup fade-out animation
    },
    customClass: {
        container: 'swal-on-top swal2-html-container'
    }
});

function App(){
    const userContext = useContext(AuthContext);
    const [customPatientFields, setCustomPatientFields] = useState([]);

    const loadScript = (src: string) => {
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) return;
        const tag = document.createElement('script');
        tag.src = src;
        tag.async = true;
        document.body.appendChild(tag);
    };

    useEffect(()=>{
        let currentURL = window.location.href;
        let title;
        const getProductBranding = async () => {
            let data = await SystemAPI.getProductBrandingFromURL(currentURL)
            title = data.Name;
            document.title = title
        }

        // Catch, don't throw: this only sets the page title, so a failed
        // request should not surface as an unhandled rejection (which is
        // what raises the dev-server error overlay, and in production is a
        // console error users can't act on).
        getProductBranding().catch((e) =>
            console.warn('Unable to load product branding for the page title.', e),
        );

        // Load Google Maps Places API
        loadScript(`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_PLACES_API_KEY}&libraries=places&loading=async`);

    },[]);// runs on load


    const getNavRoute = (comp:any)=>{
        return(
            <React.Fragment>
                <Nav />
                {comp}
                {/* <Footer/> */}
            </React.Fragment>
        )
    }

    const getAdminNavRoute = (comp:any, props)=>{
        document.body.style.backgroundColor = 'white'
        return (
            <> 
            { userContext && 
                <React.Fragment>
                    
                    <SkipLink targetId="main-content" label="Skip to Main Content" />
                    <AdminPanel {...props} />
                    {comp}
                </React.Fragment>
            }
            </>
        )
    }

    const getLoginRoute = (comp:any)=>{
        return (
            <React.Fragment>
                {comp}
            </React.Fragment>
        )
    }
    return (
        <BrowserRouter>
            <React.Fragment>
                <Switch>
                    {/* Dev-only dashboard preview: renders a dashboard component
                        against fixture data with no backend, DB or login.
                        See src/dashboards/preview/DashboardPreview.tsx.

                        The import is LAZY on purpose. A static import would be
                        bundled into main.js even with this NODE_ENV guard —
                        webpack can't tree-shake it without `sideEffects: false`,
                        which this package.json doesn't set — so the preview and
                        its fixtures shipped to production while merely being
                        unreachable. Lazy + referenced only inside the guard keeps
                        it in a chunk that production never requests. */}
                    {process.env.NODE_ENV === 'development' ? (
                        <Route
                            path="/dashboard-preview"
                            render={() => (
                                <Suspense fallback={<div className={'p-4 text-muted'}>Loading preview…</div>}>
                                    <LazyDashboardPreview />
                                </Suspense>
                            )}
                            exact
                        />
                    ) : null}
                    <Route path="/" render={(props) => getNavRoute(<Home />)} exact />
                    {/* <Route path="/private" render={(props) => getNavRoute(<PrivatePod />)} exact />
                    <Route path="/appointment" render={(props) => getNavRoute(<PatientForm />)} exact /> */}
                    <Route path="/results" render={(props) => getNavRoute(<ResultsForm />)} exact />
                    <Route path="/admin" render={(props)=> getAdminNavRoute(<AdminHomePage />, props)} exact /> 
                    {/* <Route path="/admin/CheckIn" render={(props) => getAdminNavRoute(<CheckIn />, props)} exact /> */}
                    <Route path="/admin/Submission" render={(props) => getAdminNavRoute(<WalkinForm />, props)} exact />
                    {/* <Route path="/admin/RapidTest" render={(props) => getAdminNavRoute(<RapidTestManagement />, props)} exact /> */}
                    {/* <Route path="/admin/Schedules" render={(props) => getAdminNavRoute(<Schedules />, props)} exact /> */}
                    <Route path="/admin/Messages" render={(props) => getAdminNavRoute(<Alert />, props)} exact />
                    <Route path="/admin/Samples" render={(props) => getAdminNavRoute(<SamplesReport />, props)} exact />


                    <Route path="/admin/Samples/:facilityID" render={(props) => getAdminNavRoute(<SamplesReport />, props)} exact />


                    {/* <Route path="/admin/InternalSampleGenerator" render={(props) => getAdminNavRoute(<FakeSampleGenerator />, props)} exact /> */}
                    <Route path="/admin/AuditLogs" render={(props) => getAdminNavRoute(<AuditLogs />, props)} exact />
                    <Route path="/admin/Facility" render={(props) => getAdminNavRoute(<Facility />, props)} exact />
                    <Route path="/admin/User" render={(props) => getAdminNavRoute(<UserManagement />, props)} exact />
                    <Route path="/admin/Test" render={(props) => getAdminNavRoute(<TestManagement />, props)} exact />
                    <Route path="/admin/Service" render={(props) => getAdminNavRoute(<ServicesManagement />, props)} exact />
                    <Route path="/admin/Patient" render={(props) => getAdminNavRoute(<PatientManagement />, props)} exact />
                    <Route path="/admin/PatientRecord/:uuid" render={(props) => getAdminNavRoute(<PatientRecord user={props.match.params.uuid} fromPatientMgmt={true}/>, props)} exact />
                    <Route path="/admin/CustomFields" render={(props) =>  getAdminNavRoute(<CustomFields/>, props)} exact/>
                    <Route path="/admin/PatientFields" render={(props) =>  getAdminNavRoute(<PatientFields/>, props)} exact/>
                    <Route path="/admin/Communication" render={(props) => getAdminNavRoute(<CommunicationTemplates />, props)} exact />
                    <Route path="/admin/Result" render={(props) =>  getAdminNavRoute(<ResultsManagement/>, props)} exact/>
                    <Route path="/admin/Banner" render={(props) =>  getAdminNavRoute(<BannerManagement/>, props)} exact/>
                    <Route path="/admin/ReportSettings" render={(props) => getAdminNavRoute(<ReportSettings />, props)} exact />
                    <Route path="/admin/PasswordRequirements" render={(props)=> getAdminNavRoute(<PasswordSettings />, props)} exact />
                    <Route path="/admin/Pricing" render={(props)=> getAdminNavRoute(<PricingManagement />, props)} exact />
                    <Route path="/admin/Discounts" render={(props)=> getAdminNavRoute(<DiscountManagement />, props)} exact />
                    <Route path="/admin/File" render={(props)=> getAdminNavRoute(<DocumentUpload />, props)} exact />
                    <Route path="/admin/Transactions" render={(props)=> getAdminNavRoute(<Transactions />, props)} exact />
                    <Route path="/admin/Dashboards" render={(props)=> getAdminNavRoute(<Dashboards mount={"internal"} />, props)} exact />
                    <Route path="/admin/ProviderDashboards" render={(props)=> getAdminNavRoute(<Dashboards mount={"external"} />, props)} exact />
                    <Route path="/admin/Import" render={(props)=> getAdminNavRoute(<SampleCSVImport />, props)} exact />
                    <Route path="/admin/OrderHistory" render={(props)=> getAdminNavRoute(<OrderHistory />, props)} exact />
                    <Route path="/admin/Products" render={(props)=> getAdminNavRoute(<ProductManagmentPage />, props)} exact />
                    <Route path="/admin/Ora-Protek" render={(props)=> getAdminNavRoute(<ProbioticsOrderPage />, props)} exact />
                    <Route path="/admin/HomeKit" render={(props)=> getAdminNavRoute(<AtHomeKitOrderPage />, props)} exact />
                    <Route path="/admin/KitManagement" render={(props)=> getAdminNavRoute(<KitInventoryManagement />, props)} exact />
                    <Route path="/admin/ReportsUpload" render={(props)=> getAdminNavRoute(<ReportsUploadPage />, props)} exact />

                    
                    
                    
                    
                    {/* <Route path="/confirmation" render={(props) => getNavRoute(<Confirmation />)} exact />
                    <Route path="/checkin" render={(props) => <PatientCheckIn />} exact />
                    <Route path="/retrieve" render={(props) => getNavRoute(<RetrieveConfirmation />)} exact /> */}
                    <Route path="/logout" render={(props)=> getNavRoute(<LoggedOut /> )} exact />
                    <Route path="/loggedout" render={(props) => getNavRoute(<LoggedOut />)} exact />
                    <Route path="/login" render={(props)=> getLoginRoute(<Login form_action={'login'} />) } exact />
                    <Route path="/forgotPassword" render={(props) => getLoginRoute(<ForgotPassword />)} exact/>
                    <Route path="/__/auth/:action" render={(props)=> getLoginRoute(<Login form_action={props.match.params.action} />)} />
                    <Redirect to={"/admin"} />
                </Switch>
            </React.Fragment>
        </BrowserRouter>);
}

export default App;
